import styled from 'styled-components';

const TrailBar = styled('div')<{ width: number }>`
  position: absolute;
  top: 8px;
  height: 8px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  left: 0;
  z-index: -15;
  width: ${(props) =>
    `calc(${props.width * 100}% + ${(1 - props.width) * 16}px)`};
  background-color: ${(props) => props.theme.colors.brandBlue};
`;

export default TrailBar;
